<template>
    <h2>Het is hier nog leeg</h2>
    <p>Er zijn nog geen {{ naam }} toegevoegd aan de website. Druk op het plusje rechtsonderaan om een {{ naam }} toe te voegen.</p>
    <div class="nothingFound__img">
<!--         <img src="assets/nothingfound.png" alt="">-->    
    </div>
</template>
<script>
export default {
    props:["naam"]
}
</script>